import { AxiosResponse } from 'axios';
import { axiosWithRetry } from 'utils/axios';
import { DEFAULT_RETRIES } from 'utils/axios/constants';

import { HTTP_REQUEST_METHODS } from 'constants/http';
import { ChatContextStateType } from 'hooks/chatContext/types';
import { AuthenticationStateType } from 'hooks/authentication/types';
import {
  HandraiserRequest,
  DynamicHandRaiserResponseType,
  DynamicHandraiserContextType,
} from './types/handraiser.types';

export const getHandraiser = async (
  currentState: {
    chatContextState: ChatContextStateType;
    authenticationState: AuthenticationStateType;
  },
  handraiserContext: DynamicHandraiserContextType,
  handraiserName: string,
): Promise<DynamicHandRaiserResponseType> => {
  const { authenticationState, chatContextState } = currentState;
  const {
    mojoContext: { info },
  } = chatContextState;

  const url = `${process.env.CHAT_BACKEND_BASE_URL}/handraiser`;

  const request: HandraiserRequest = {
    carvanaUserId: info.user_info.carvana_user_id,
    browserCookieId: info.user_info.carvana_browser_cookie_id,
    conversationId: authenticationState.propel.conversationId,
    handraiserName,
    handraiserContext,
  };

  const { data }: AxiosResponse<DynamicHandRaiserResponseType> = await axiosWithRetry({
    method: HTTP_REQUEST_METHODS.POST,
    retries: DEFAULT_RETRIES,
    body: request,
    url,
  });
  return data;
};
